import Reactor from '../reactor';

const LOAD_COMBINED_INFO = 'LOAD_COMBINED_INFO';
const ADD_STUDENT_BID = 'ADD_STUDENT_BID';
const SET_STUDENT_LOADED = 'SET_STUDENT_LOADED';
const LOAD_STUDENT_TERM_DATA = 'LOAD_STUDENT_TERM_DATA';
const LOAD_GROWTH_PROJECTIONS = 'LOAD_GROWTH_PROJECTIONS';
const LOAD_GROWTH_PERCENTILES = 'LOAD_GROWTH_PERCENTILES';
const CREATE_EMPTY_GROWTH_PROJECTIONS = 'CREATE_EMPTY_GROWTH_PROJECTIONS';
const CREATE_EMPTY_GROWTH_PERCENTILES = 'CREATE_EMPTY_GROWTH_PERCENTILES';
const CHANGE_SELECTED_TERM_NUMBER = 'CHANGE_SELECTED_TERM_NUMBER';
const LOAD_NORM_DATA_FOR_GOAL_SETTING = 'LOAD_NORM_DATA_FOR_GOAL_SETTING';
const CREATE_EMPTY_NORM_DATA_FOR_GOAL_SETTING = 'CREATE_EMPTY_NORM_DATA_FOR_GOAL_SETTING';
const ADD_OR_UPDATE_GROWTH_GOAL = 'ADD_OR_UPDATE_GROWTH_GOAL';
const STORE_ENTIRE_STUDENT_DATA_MAP = 'STORE_ENTIRE_STUDENT_DATA_MAP';
const DELETE_GROWTH_GOAL = 'DELETE_GROWTH_GOAL';
const CLEAR_STUDENT_DATA = 'CLEAR_STUDENT_DATA';
const STORE_LINKING_STUDIES = 'STORE_LINKING_STUDIES';
const CREATE_EMPTY_LINKING_STUDY_DATA = 'CREATE EMPTY LINKING STUDY DATA';
const STORE_HIGHLIGHTS_DATA = 'STORE_HIGHLIGHTS_DATA';
const CREATE_EMPTY_STUDENT_PLACEHOLDER = 'CREATE_EMPTY_STUDENT_PLACEHOLDER';
const COMPLETE_STUDENT_LOAD = 'COMPLETE_STUDENT_LOAD';

export default {
    LOAD_COMBINED_INFO,
    ADD_STUDENT_BID,
    SET_STUDENT_LOADED,
    LOAD_STUDENT_TERM_DATA,
    LOAD_GROWTH_PROJECTIONS,
    LOAD_GROWTH_PERCENTILES,
    CREATE_EMPTY_GROWTH_PROJECTIONS,
    CREATE_EMPTY_GROWTH_PERCENTILES,
    CHANGE_SELECTED_TERM_NUMBER,
    LOAD_NORM_DATA_FOR_GOAL_SETTING,
    CREATE_EMPTY_NORM_DATA_FOR_GOAL_SETTING,
    ADD_OR_UPDATE_GROWTH_GOAL,
    STORE_ENTIRE_STUDENT_DATA_MAP,
    DELETE_GROWTH_GOAL,
    CLEAR_STUDENT_DATA,
    STORE_LINKING_STUDIES,
    CREATE_EMPTY_LINKING_STUDY_DATA,
    STORE_HIGHLIGHTS_DATA,
    CREATE_EMPTY_STUDENT_PLACEHOLDER,
    COMPLETE_STUDENT_LOAD,

    loadCombinedInfo(studentBid, combinedInfo) {
        Reactor.dispatch(LOAD_COMBINED_INFO, { studentBid, combinedInfo });
    },
    addStudentBid(studentBid) {
        Reactor.dispatch(ADD_STUDENT_BID, studentBid);
    },
    setStudentLoaded(studentBid) {
        Reactor.dispatch(SET_STUDENT_LOADED, studentBid);
    },
    loadStudentTermData(studentBid, termData) {
        Reactor.dispatch(LOAD_STUDENT_TERM_DATA, { studentBid, termData });
    },
    loadGrowthProjections(studentBid, projections) {
        Reactor.dispatch(LOAD_GROWTH_PROJECTIONS, { studentBid, projections });
    },
    loadGrowthPercentiles(studentBid, projections) {
        Reactor.dispatch(LOAD_GROWTH_PERCENTILES, { studentBid, projections });
    },
    changeSelectedTermNumber: function(
        studentBid,
        termNumber,
        updatePreferredSubject = false,
        delayStateUpdateUntilTransitionComplete = false
    ) {
        Reactor.dispatch(CHANGE_SELECTED_TERM_NUMBER, {
            studentBid,
            termNumber,
            updatePreferredSubject,
            delayStateUpdateUntilTransitionComplete,
        });
    },
    createEmptyGrowthProjectionsForStudent: function(studentBid) {
        Reactor.dispatch(CREATE_EMPTY_GROWTH_PROJECTIONS, studentBid);
    },
    createEmptyGrowthPercentilesForStudent: function(studentBid) {
        Reactor.dispatch(CREATE_EMPTY_GROWTH_PERCENTILES, studentBid);
    },
    loadNormDataForGoalSetting: function(studentBid, termNumber, subject, data) {
        Reactor.dispatch(LOAD_NORM_DATA_FOR_GOAL_SETTING, { studentBid, termNumber, subject, data });
    },
    createEmptyNormDataForGoalSetting: function(studentBid, termNumber, subject) {
        Reactor.dispatch(CREATE_EMPTY_NORM_DATA_FOR_GOAL_SETTING, { studentBid, termNumber, subject });
    },
    addOrUpdateGrowthGoal: function(studentBid, goal) {
        Reactor.dispatch(ADD_OR_UPDATE_GROWTH_GOAL, { studentBid, goal });
    },
    storeEntireDataMap: function(studentBid, studentData) {
        Reactor.dispatch(STORE_ENTIRE_STUDENT_DATA_MAP, { studentBid, studentData });
    },
    deleteGrowthGoal: function(studentBid, goal) {
        Reactor.dispatch(DELETE_GROWTH_GOAL, { studentBid, goal });
    },
    clearStudentData: function() {
        Reactor.dispatch(CLEAR_STUDENT_DATA);
    },
    storeLinkingStudies: function(studentBid, subjectBid, studies) {
        Reactor.dispatch(STORE_LINKING_STUDIES, { studentBid, subjectBid, studies });
    },
    createEmptyLinkingStudyData: function(studentBid, subjectBid) {
        Reactor.dispatch(CREATE_EMPTY_LINKING_STUDY_DATA, { studentBid, subjectBid });
    },
    storeHighlightsData: function(studentBid, highlights) {
        Reactor.dispatch(STORE_HIGHLIGHTS_DATA, { studentBid, highlights });
    },
    createEmptyStudentPlaceholder: function() {
        Reactor.dispatch(CREATE_EMPTY_STUDENT_PLACEHOLDER);
    },
    completeStudentLoad: function(studentBid) {
        Reactor.dispatch(COMPLETE_STUDENT_LOAD, studentBid);
    },
};
